function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 84.21,
  height: 69.1,
  transform: "translate(271.17 189.13)",
  fill: "#015b80",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M369.25,281.49c-2.7-4.28-13.87-23.26-13.87-23.26H337.56l9.17,23.26Z",
  fill: "#015b80",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-117.35 -124.468)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 72.24,
  cy: 8.78,
  rx: 72.24,
  ry: 8.78,
  transform: "translate(117.35 408.25)",
  fill: "#015b80"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 72.24,
  cy: 8.78,
  rx: 72.24,
  ry: 8.78,
  transform: "translate(117.35 408.25)",
  fill: "#fff",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M339.08,417c0,2.42-16.13,4.38-36,4.38s-36-2-36-4.38,16.12-4.37,36-4.37S339.08,414.62,339.08,417Z",
  fill: "#015b80"
}), /*#__PURE__*/React.createElement("path", {
  d: "M339.08,417c0,2.42-16.13,4.38-36,4.38s-36-2-36-4.38,16.12-4.37,36-4.37S339.08,414.62,339.08,417Z",
  fill: "#fff",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M204,127.79s-5.59-4.39-12-2.2-11.27,12.87-13,21.55-8.38,15.26-6.78,25.44,13.17,11.77,27.14,13.27,21.55-.2,28.13-9.38,3.79-20.35-.1-30.23-10.37-19.05-15.76-20.75S204,127.79,204,127.79Z",
  fill: "#263238",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.9,180a16.549,16.549,0,0,0,2.93,1",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.6,134.9a68.93,68.93,0,0,1-8.6,14.28c-5.72,7.35-18.37,14.29-19.18,22a7.35,7.35,0,0,0,1.77,5.77",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M225.81,171.77a12.859,12.859,0,0,1-1.58,2.72",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M221,152.45s6.43,7.42,5.81,15.34",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.38,130.81a15.77,15.77,0,0,0-13.47,5.31c-.23.26-.44.52-.64.78",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.49,319.3l-1.25,19.24s-5.32,25.81-7,36.45-4.76,26.82-5.32,26.82-9.74,5.55-12.68,10.08.79,6.45,4.87,5,9.62-5.55,11.43-10.42,2.71-6.68,2.83-7.47,19.47-52.74,21.39-58.29,6-21.85,6-21.85l9.51-32.26s10.18,33.17,10.3,34.64,10.52,86.25,11,89.42.34,5.43,2.26,6.11,6.45.68,8.83.68,10.64,1.25,14.71.23,4.53-1.7,1.7-3.74-18.55-3.34-20-9.28c-.12-.45-.23-87.72-.23-87.72s-1.36-28.86-3.62-37h-52.3Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.1,416.87c4.07-1.48,9.62-5.55,11.43-10.42l.38-1c-2.31,2.46-6,5.88-6,5.88a7.3,7.3,0,0,0-1.47-3.17,2.65,2.65,0,0,0-2.61-.79l4-4.4c-3,1.86-8.4,5.66-10.52,8.93C135.28,416.41,139,418.34,143.1,416.87Z",
  fill: "#263238",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M243,413.92c-1.94-1.39-9.91-2.44-15.23-4.87a1.8,1.8,0,0,0-.5.69,20,20,0,0,0-.79,2.94l-11-2.35v.31c.45,3.17.34,5.43,2.26,6.11s6.45.68,8.83.68,10.64,1.25,14.71.23S245.87,416,243,413.92Z",
  fill: "#263238",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.73,233s-5.19,2.39-11.47,13.67c-6.87,12.31-5.69,19.15-5.79,34s-.4,39.5-.4,39.5,19,5.09,32.63,4.29,30.92-3.89,30.92-3.89-3.69-50.28-7.18-64.74-5.59-21-5.59-21a82.831,82.831,0,0,1-20.35.3C180.93,234,179.73,233,179.73,233Z",
  fill: "#263238",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.59,277.47c.52,1.71,1,3.44,1.42,5.17",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.54,249.17a166.589,166.589,0,0,1,10.34,23.12",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M307.12,223.44c-.6-.4-10.43-1.94-10.43-1.94l-1.92-.79s11.9.95,12,.45.5-1.1-.3-1.2-16.11-3.21-16.11-3.21,3.89-3.68,4.39-4.48,1.19-2.4.39-2.4-1,.5-2.09,1.2-5.39,2.4-6.59,3.39-4.78,3.59-4.78,3.59l-41.58-5.72s-14.6-18-17.77-21.84a41.47,41.47,0,0,0-7.47-6.8c-3.06-1.35-3,.91-3,.91l6.39,28.4s16.53,9.85,17.55,9.85,45.68,1.48,45.68,1.48a54.527,54.527,0,0,1,4.88,2.59c1.88,1.19,13.87,5,13.87,5s.8-.4-.1-1.1-6.68-3.49-6.68-3.49l12,2.6s.7-.5.4-1-11-4.59-11-4.59l12,.6S307.71,223.84,307.12,223.44Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M237.59,209.24c-4.31-5.31-12.92-15.91-15.26-18.75a41.47,41.47,0,0,0-7.47-6.8c-3.06-1.35-3,.91-3,.91l6.39,28.4s7.46,4.44,12.66,7.36Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.4,181.26s-8.68.4-14,6.29-4.69,18.85-2.49,26.63,5,12.07,4.39,14.77-2.79,3.59-1.6,6.08,8.08,5.19,20.25,4.79,14.47-3,14.57-5.28-.8-4.19-.5-5.59,9.08-9.18,9.08-17.76-3.79-11.57-4.69-17.76-.6-7.08-4.29-9.78S198.29,179.56,193.4,181.26Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.46,211a41.42,41.42,0,0,1-9.57,6",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.42,212s-2.15,6.94-7.42,10.77",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M211.96,187.54l1,9.58-4.2-4.89Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.37,197.92l5.59-10.38-5.09-5.48Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M195.6,164.3a42.559,42.559,0,0,1,1.29,10.58,39,39,0,0,1-.7,6.88l10.18,16.16,2.89-15,1.9-10.38S199.59,171.88,195.6,164.3Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.77,189.24l.6,8.68-2.99-4.69Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M192.8,181.36l9.28,16.66,3.69-8.78-9.87-13.57Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 84.21,
  height: 69.1,
  transform: "translate(271.17 189.13)",
  fill: "#015b80"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 84.21,
  height: 69.1,
  transform: "translate(271.17 189.13)",
  opacity: 0.2
})), /*#__PURE__*/React.createElement("rect", {
  width: 84.21,
  height: 69.1,
  transform: "translate(271.17 189.13)",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 84.21,
  height: 69.1,
  transform: "translate(253.34 189.13)",
  fill: "#015b80",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M369.25,281.49c-2.7-4.28-13.87-23.26-13.87-23.26H337.56l9.17,23.26Z",
  fill: "#015b80"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M369.25,281.49c-2.7-4.28-13.87-23.26-13.87-23.26H337.56l9.17,23.26Z",
  opacity: 0.2
})), /*#__PURE__*/React.createElement("path", {
  d: "M369.25,281.49c-2.7-4.28-13.87-23.26-13.87-23.26H337.56l9.17,23.26Z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M239.42,281.49c2.7-4.28,13.86-23.26,13.86-23.26h17.83l-9.17,23.26Z",
  fill: "#015b80",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.28,258.23l-7.75,23.26h87.95l4.08-23.26Z",
  fill: "#015b80",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  y2: 23.14,
  transform: "translate(366.22 214.13)",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  y2: 18.76,
  transform: "translate(370.6 224.14)",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  y2: 14.38,
  transform: "translate(244.29 237.27)",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  y2: 11.25,
  transform: "translate(240.54 245.4)",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.93,206.1a46.15,46.15,0,0,0,10.28,8.68c6,3.59,28,16.06,29.73,16.76s54.27-7.88,54.27-7.88,3,1.4,4.89,2.59,13.87,5,13.87,5,.8-.4-.1-1.09-6.68-3.5-6.68-3.5l12,2.6s.7-.5.4-1-11-4.59-11-4.59l12,.6s.9-1.1.3-1.5-12.89-3.2-12.89-3.2,13.07-1.1,13.17-1.6.5-1.09-.3-1.19-17.16-1.7-17.16-1.7,4.29-2.69,4.79-3.49,1.2-2.4.4-2.4-1,.5-2.09,1.2-5.39,2.4-6.59,3.39-4.79,3.6-4.79,3.6l-48.08.1L195.5,193.93",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M298.85,216.78c-.79-.1-17.16-1.7-17.16-1.7s4.29-2.69,4.79-3.49,1.2-2.4.4-2.4-1,.5-2.09,1.2-5.39,2.4-6.59,3.39-4.79,3.6-4.79,3.6l-48.08.1L220,213.25c-2,3.51-5.74,10.09-8.17,14.43,3.74,2.08,6.57,3.63,7.14,3.86,1.7.7,54.27-7.88,54.27-7.88s3,1.4,4.89,2.59,13.87,5,13.87,5,.8-.4-.1-1.09-6.68-3.5-6.68-3.5l12,2.6s.7-.5.4-1-11-4.59-11-4.59l12,.6s.9-1.1.3-1.5-12.92-3.2-12.92-3.2,13.07-1.1,13.17-1.6S299.65,216.88,298.85,216.78Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.34,155.92a1.43,1.43,0,0,1,2.5.6,8.08,8.08,0,0,1-1.6,6.18c-1.1,1.1-2.1,1.4-2.1,0a63.824,63.824,0,0,1,1.2-6.78Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.06,138.44a20.41,20.41,0,0,1-5.87,12.91,48.851,48.851,0,0,1-10.76,8s.58,3.13,1.76,4.11,3.52.79,3.52.79a25.37,25.37,0,0,0,6.46,9.78c4.69,4.3,10.17,3.91,13.3-2.54s4.7-12.92,4.31-16.64l-.39-3.72S208.21,145.48,206.06,138.44Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.9,
  cy: 1.6,
  rx: 0.9,
  ry: 1.6,
  transform: "translate(204.57 154.58)",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.9,
  cy: 1.6,
  rx: 0.9,
  ry: 1.6,
  transform: "translate(209.46 167.35)",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.9,
  cy: 1.6,
  rx: 0.9,
  ry: 1.6,
  transform: "translate(213.25 154.58)",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.35,154.48a9.4,9.4,0,0,0-.3,3.69c.3,1.7,1.7,4.59.5,5.09a3.29,3.29,0,0,1-3.39-.4",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.87,153.29s.48-3.06,4.49-2.71",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M213.61,151.52s3.74-3,4.95,2.49",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}));

function SvgNewEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 253.75,
    height: 301.342,
    viewBox: "0 0 253.75 301.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEmptyState);
export default __webpack_public_path__ + "new-empty-state.b9e8d3f.svg";
export { ForwardRef as ReactComponent };